export default __webpack_public_path__ + "static/media/btn_moodVeryBad.b5482e1b.png";